import { Component, Inject } from '@angular/core';
import { MODAL_DATA } from 'projects/shared/src/lib/interfaces/modal';
import { ModalComponent } from '../modal/modal.component';


@Component({
    selector: 'gbc-validation-messages-modal',
    templateUrl: './validation-messages-modal.component.html',
    styleUrls: ['./validation-messages-modal.component.scss'],
    imports: [ModalComponent],
})
export class ValidationMessagesModalComponent {
  constructor(
    @Inject(MODAL_DATA)
    public data: { validationMessages: string[]; title: string },
  ) {}
}
